import { Col, Row, Button, Form, Modal } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";

// Utils
import { fetchWithToken } from "../../api/fetch";
import toastConfig from "../../utils/toastConfig";

/**
 * Componente para el modal de formulario de nota
 * 
 * @param {Object} props - Propiedades del componente
 * @param {Boolean} props.show - Estado del modal
 * @param {Function} props.handleClose - Función para cerrar el modal
 * @param {Object} props.info - Información de la nota
 * @param {Function} props.callBack - Función de retorno
 * @returns {JSX.Element} Componente de React
 */
const ModalFormNote = ({ show, handleClose, info, callBack }) => {
  /**
   * Maneja el guardado de la nota
   * 
   * @returns {void} No retorna nada
   */
  const handleSave = async () => {
    const nota = document.getElementById("note").value;

    const resp = await fetchWithToken(
      info.path,
      info.action === "POST"
        ? {
            id_user: info.id,
            nota,
          }
        : {
            id: info.id,
            nota,
          },
      info.action
    );

    if (resp.ok) {
      toast.success(resp.msg, toastConfig);
      callBack();
      handleClose();
    } else {
      toast.error(resp.msg, toastConfig);
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {info.action === "POST" ? "Nueva Nota" : "Editar Nota"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={(e) => e.preventDefault()}>
            <Row>
              <Col xl={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Contenido de la nota</Form.Label>
                  <Form.Control type="text" name="nota" id="note" required />
                </Form.Group>
              </Col>
              <ToastContainer />
            </Row>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              handleClose();
            }}
          >
            Cancelar
          </Button>

          <Button
            variant="primary"
            onClick={() => {
              handleSave();
            }}
          >
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalFormNote;
